import { z } from 'zod';
import { UnitType } from './geo.js';
/**
 * Administration of the organisational structure (Qark → Bashki → Degë).
 * Party and state structures change over time, so every level can be added,
 * renamed, moved and deactivated from the UI. See docs/04-geo-hierarchy.md.
 */
const code = z
    .string()
    .trim()
    .toUpperCase()
    .min(1, 'Shkruani kodin.')
    .max(40)
    .regex(/^[A-Z0-9-]+$/, 'Kodi mund të ketë vetëm shkronja pa theks, shifra dhe vizë (-).');
const name = z.string().trim().min(2, 'Emri duhet të ketë të paktën 2 shkronja.').max(150);
const unitType = z.enum([UnitType.BRANCH, UnitType.ADMINISTRATIVE_UNIT]);
export const countyCreateSchema = z.object({ code, name, sortOrder: z.number().int().optional() });
export const countyUpdateSchema = z.object({
    code: code.optional(),
    name: name.optional(),
    sortOrder: z.number().int().optional(),
    isActive: z.boolean().optional(),
});
export const municipalityCreateSchema = z.object({
    countyId: z.string().uuid(),
    code,
    name,
    unitType: unitType.default(UnitType.BRANCH),
});
export const municipalityUpdateSchema = z.object({
    /** Moving a municipality to another county. Past activities keep their original county. */
    countyId: z.string().uuid().optional(),
    code: code.optional(),
    name: name.optional(),
    unitType: unitType.optional(),
    isActive: z.boolean().optional(),
});
export const unitCreateSchema = z.object({
    municipalityId: z.string().uuid(),
    code,
    name,
    sortOrder: z.number().int().optional(),
});
export const unitUpdateSchema = z.object({
    /** Moving a branch to another municipality. Past activities keep their original location. */
    municipalityId: z.string().uuid().optional(),
    code: code.optional(),
    name: name.optional(),
    sortOrder: z.number().int().optional(),
    isActive: z.boolean().optional(),
});
export const branchImportSchema = z.object({
    /** Raw CSV text: municipality_code,branch_code,branch_name (header row required). */
    csv: z.string().min(1).max(2_000_000),
    /** Validate and report without writing anything. */
    dryRun: z.boolean().default(true),
});
//# sourceMappingURL=structure.js.map